import { render } from "./AddDistance.vue?vue&type=template&id=6a0c66dc&ts=true"
import script from "./AddDistance.vue?vue&type=script&lang=ts"
export * from "./AddDistance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__